<!--
 * @Description: 
 * @Autor: soul(佘家骏) 
 * @Date: 2021-12-28 14:19:56
 * @LastEditors: soul(佘家骏) 
 * @LastEditTime: 2022-07-11 18:12:11
-->
<template>
  <div class="bg">
    <BaseImg :option="{
      style: {
        margin: '14px 0 0 12px',
        alignSelf: 'flex-start',
        width: '149px',
      },
      url: 'logo.png',
    }"/>
    <BaseImg :option="{
      style: {
        margin: '28px auto 0',
      },
      url: 'slogan.png',
    }"/>
    <div class="turntable-wrapper">
      <div class="game-info">
        剩余抽奖次数：<span>{{gameCounts}}</span>
      </div>
      <div class="luck-wrapper" v-if="myprizeList.length > 0">
        <ul class="nineGrid">
          <li class="row">
            <div v-for="(n, key) in 3" :key="n" :class="index === key ? `active` : ``">
              <div class="wrapper">
                <img :src="myprizeList[key].prizeIcon + '?v=' + $config.OSSVersion" alt />
              </div>
              <div class="mask"></div>
            </div>
          </li>
          <li class="row">
            <div :class="index === 7 ? 'active': ''">
              <div class="wrapper">
                <img :src="myprizeList[7].prizeIcon + '?v=' + $config.OSSVersion" alt />
              </div>
              <div class="mask"></div>
            </div>
            <div class="getLuck" @click="startLottery">
              <img :src="imgHost + 'draw-btn.png?v=' + $config.OSSVersion" alt />
            </div>
            <div :class="index === 3 ? 'active': ''">
              <div class="wrapper">
                <img :src="myprizeList[3].prizeIcon + '?v=' + $config.OSSVersion" alt />
              </div>
              <div class="mask"></div>
            </div>
          </li>
          <li class="row">
            <div v-for="(n, key) in 3" :key="n" :class="index === 6-key ? `active` : ``">
              <div class="wrapper">
                <img :src="myprizeList[(6-key)].prizeIcon + '?v=' + $config.OSSVersion" alt />
              </div>
              <div class="mask"></div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <BasePaySuccess ref="PaySuccess" />
    <BaseBtnHome />
  </div>
</template>

<script>
import { MessageBox } from "mint-ui";
export default {
  components: {
  },
  props: {},
  data() {
    return {
      myprizeList: [], //奖品列表
      index: -1, // 当前转动到哪个位置，起点位置
      count: 8, // 总共有多少个位置
      timer: 0, // 每次转动定时器
      speed: 200, // 初始转动速度
      times: 0, // 转动次数
      cycle: 20, // 转动基本次数：即至少需要转动多少次再进入抽奖环节
      prize: -1, // 中奖位置
      gameCounts: 0, //设置抽奖次数
      click: true, //是否禁止抽奖
      prizeId: 0, // 中奖id
      helperHeadImg: [],
    };
  },
  filters: {
  },
  watch: {
  },
  computed: {
    showHeadImg() {
      const thisLength = this.helperHeadImg.length
      if (thisLength % 2 === 1) {
        return this.helperHeadImg[thisLength - 1]
      } else {
        if (thisLength > 2) {
          return [
            this.helperHeadImg[thisLength - 2], this.helperHeadImg[thisLength - 1], 
          ]
        } else {
          return []
        }
      }
    }
  },
  methods: {
    async getCount() {
      const data = await this.$httpdf.get(this.apiHost + 'user/gameCount')
      if (data.code == 0) {
        this.gameCounts = data.data.gameCount
      } else {
        MessageBox.alert(data.msg).then(()=> {
          this.$router.go(-1)
        })
      }
    },
    // 开始抽奖
    startLottery() {
      if (!this.click) {
        return;
      }
      this.initBgm(); //初始化音乐
      // this.startLottery(); //开始抽奖
      window.ConfigAudios.play();
      this.gameCounts--;
      this.speed = 200;
      this.click = false;
      this.startRoll();
    },
    // 开始转动
    startRoll() {
      if (this.click === true) { 
        return
      }
      console.log("======>开始抽奖", 1);
      this.times += 1; // 转动次数
      this.oneRoll(); // 转动过程调用的每一次转动方法，这里是第一次调用初始化
      // 如果当前转动次数达到要求 && 目前转到的位置是中奖位置
      if (this.times > this.cycle + 10 && this.prize === this.index) {
        clearTimeout(this.timer); // 清除转动定时器，停止转动
        setTimeout(()=> {
          this.showPrize()
        }, 1000)
      } else {
        if (this.times < this.cycle) {
          this.speed -= 10; // 加快转动速度
        } else if (this.times === this.cycle) {
          // 随机获得一个中奖位置
          this.getLottery();
        } else if (
          this.times > this.cycle + 10 &&
          ((this.prize === 0 && this.index === 7) ||
            this.prize === this.index + 1)
        ) {
          this.speed += 110;
        } else {
          this.speed += 20;
        }

        if (this.speed < 40) {
          this.speed = 40;
        }
        this.timer = setTimeout(this.startRoll, this.speed);
      }
    },
    // 每一次转动
    oneRoll() {
      let index = this.index; // 当前转动到哪个位置
      const count = this.count; // 总共有多少个位置
      index += 1;
      if (index > count - 1) {
        index = 0;
      }
      this.index = index;
    },
    // 抽奖
    async getLottery() {
      console.log("======>调用抽奖接口", 2);
      let that = this;
      that.click = false;
      //获取奖品
      const data = await that.$httpdf.get(this.apiHost + 'lucky/prize/lottery', {
        secret: this.$route.query.secret
      })
      if (data.code == 0) {
        this.prizeId = data.data;
        if (this.myprizeList.length > 0) {
          this.myprizeList.forEach((v, i) => {
            if (v.id == this.prizeId) {
              this.prize = i;
              console.log(this.prize,'prize');
              return;
            }
          });
        }
      } else {
        this.prize = 7;
      }
    },
    showPrize() {
      if (this.prize != 7) {
        this.$modal.drawForm.alert({ prizeId: this.prizeId, isSecret: true }).then(async ()=> {
          await this.getCount()
          if (this.gameCounts === 0) {
            this.$router.go(-1)
          } else {
            this.getPrize();
          }
        })
      } else {
        this.$modal.drawForm.alert(
          {
            drawTxt: 2,
            thanksTxt: '我们已经玩出感情了，再来一次，中奖概率会更大',
            btnTxt: '呼朋唤友',
            btnStatus: 1
          }
        ).then(async () => {
          await this.getCount()
          if (this.gameCounts === 0) {
            this.$router.go(-1)
          } else {
            this.getPrize();
          }
        });
      }
      this.prize = -1;
      this.times = 0;
      this.click = true;
      this.showToast = true;
    },
    initBgm() {
      if (!window.ConfigAudios) {
        window.ConfigAudios = new Audio();
        window.ConfigAudios.src =
          "http://assets.rurushishi.com/activies/mfAct/voice.mp3";
        this.$wx.ready(function () {
          window.ConfigAudios.play();
        });
      } else {
        window.ConfigAudios.src =
          "http://assets.rurushishi.com/activies/mfAct/voice.mp3";
        this.$wx.ready(function () {
          window.ConfigAudios.play();
        });
      }
    },
    async getPrize () {
      const data = await this.$httpdf.get(this.apiHost + 'lucky/prize/view', { secret: this.$route.query.secret })
      if (data.code == 0) {
        let prizeList = [
          {
            prizeName: "谢谢参与",
            prizeIcon: this.imgHost + "6.png",
          }
        ]
        this.index = ''
        this.myprizeList = data.data
        this.myprizeList = [...this.myprizeList, ...prizeList]
      } else {
        MessageBox.alert(data.msg)
      }
    },
  },
  created() {
    this.getCount()
    this.getPrize()
  },
  mounted() {
    this.$wx.shareCallBackFunList.push("share1", async () => {
      await this.$httpdf.post(this.apiHost + 'share/share')
      this.$config.openYqAnalytics && this.$biz.handlerYqAnalyticsEvent('share')
      this.$modal.share.close()
      this.$config.openSalesLeads && this.$rsh5.actShare()
    });
    // this.$modal.drawForm.alert({ prizeId: 113923 })
    // this.$modal.drawForm.alert({ prizeId: 113928 })
    // this.$modal.drawForm.alert(
    //   {
    //     drawTxt: 2,
    //     thanksTxt: '我们已经玩出感情了，再来一次，中奖概率会更大',
    //     btnTxt: '呼朋唤友',
    //     btnStatus: 1
    //   }
    // )
    // this.$modal.drawForm.alert({ prizeId: 113923, user: { fromOpenName: '测试' } })
  },
};
</script>
<style lang="scss" scoped>
.bg {
  padding-bottom: 135px;
  background: url( $imgHost + 'rule_bottom.png?v=' + $OSSVersion) 0 bottom / 100% no-repeat, url( $imgHost + 'rule_bg.png?v=' + $OSSVersion) 0 0 / 100% no-repeat;
  
}
// 抽奖区域
.turntable-wrapper {
  position: relative;
  margin: 10px auto 0;
  width: 315px;
  height: 367px;
  background: url( $imgHost + 'box-frame.png?v=' + $OSSVersion) 0 0 / 100% no-repeat;
  padding: 20px 25px 0px;
  .game-info {
    margin-bottom: 65px;
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: 600;
    color: #2199FE;
    line-height: 23px;
    @extend .flex-center-center;
    span {
      font-size: 20px;
      font-weight: bold;
    }
  }
  .luck-wrapper {
    position: relative;
    .nineGrid {
      width: 100%;
      height: 100%;
      >li {
        width: 100%;
        margin: 0 auto;
        display: flex;
        &+li {
          margin-top: 4px;
        }
        >div {
          flex: 1;
          text-align: center;
          position: relative;
          &+div {
            margin-left: 4px;
          }
          &.getLuck {
            height: 76px;
          }
          &.active {
            &::after {
              content: '';
              display: block;
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              opacity: 0.5;
              border-radius: 5px;
              background-color: #000;
            }
          }
        }
        .wrapper {
          width: 100%;
          height: 76px;
        }
        img {
          display: block;
          height: 100%;
          width: auto;
        }
      }
    }
  }
}
>.tips {
  font-size: 11px;
  font-family: PingFang;
  font-weight: 500;
  color: #FFFFFF;
  text-align: center;
  margin: 15px 0 50px;
}
::v-deep .pay-layer {
  bottom: 30px;
}
</style>